// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

const ReactFilestack = React.lazy(() =>
  import(/* webpackChunkName: "filestack" */ "filestack-react").then(module => {
    const { PickerOverlay } = module;
    return { default: PickerOverlay };
  })
);

export default ReactFilestack;
